/**
 * SORA chat nudge — once-per-session prompt above the CHAT FAB.
 * Opens existing sora-ai-chat; coordinates with newsletter + cookie banner.
 * Default ~16s (min 12s) so signup popup at 11s is not stacked.
 */
(function () {
  var SESSION_KEY = "sora_chat_nudge_dismiss_v1";
  var nudge = document.querySelector("[data-sora-chat-nudge]");
  if (!nudge) return;

  var delayMs = Number(nudge.dataset.delayMs || 16000);
  var minDelayMs = Number(nudge.dataset.minDelayMs || 12000);
  var pageLoadAt = Date.now();
  var shown = false;
  var delayTimer = null;
  var scrollBound = false;

  function dismissed() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch (e) {}
  }

  function chatRoot() {
    return document.getElementById("sora-ai-chat");
  }

  function chatFab() {
    return chatRoot()?.querySelector("[data-chat-fab]");
  }

  function chatOpen() {
    var fab = chatFab();
    return fab && fab.getAttribute("aria-expanded") === "true";
  }

  function newsletterOpen() {
    var popup = document.getElementById("sora-newsletter-popup");
    return popup && popup.classList.contains("is-open");
  }

  function privacyBannerOpen() {
    if (document.querySelector("#shopify-pc__prefs__overlay")) return true;
    var prefs = document.querySelector("#shopify-pc__prefs, .shopify-pc__prefs");
    if (prefs && !prefs.hidden) {
      try {
        var prefsStyle = window.getComputedStyle(prefs);
        if (
          prefsStyle.display !== "none" &&
          prefsStyle.visibility !== "hidden" &&
          Number(prefsStyle.opacity) !== 0
        ) {
          var prefsRect = prefs.getBoundingClientRect();
          if (prefsRect.width > 8 && prefsRect.height > 8) return true;
        }
      } catch (e) {}
    }
    var selectors = [
      "#shopify-pc__banner",
      ".shopify-pc__banner__dialog",
      ".shopify-privacy-banner",
      "[data-shopify-privacy-banner]",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var banner = document.querySelector(selectors[i]);
      if (!banner || banner.hidden) continue;
      try {
        var style = window.getComputedStyle(banner);
        if (
          style.display === "none" ||
          style.visibility === "hidden" ||
          Number(style.opacity) === 0
        ) {
          continue;
        }
        var rect = banner.getBoundingClientRect();
        if (rect.width > 8 && rect.height > 8) return true;
      } catch (e) {}
    }
    return false;
  }

  function minElapsed() {
    return Date.now() - pageLoadAt >= (Number.isFinite(minDelayMs) ? minDelayMs : 12000);
  }

  function pastHero() {
    var hero = document.querySelector("[data-sora-hero-cinema]");
    if (hero) {
      var rect = hero.getBoundingClientRect();
      return rect.bottom < window.innerHeight * 0.35;
    }
    return window.scrollY > window.innerHeight * 0.85;
  }

  /* PDP: Concierge must clear gallery thumbs + price before it may appear */
  function pastPdpChrome() {
    var pdp = document.querySelector(".pdp");
    if (!pdp) return true;
    var marker =
      document.querySelector(".pdp__price-block") ||
      document.querySelector(".pdp__price") ||
      document.querySelector(".pdp__thumbs");
    if (!marker) return window.scrollY > window.innerHeight * 0.75;
    var rect = marker.getBoundingClientRect();
    return rect.bottom < window.innerHeight * 0.42;
  }

  function syncBelowFold() {
    var pdp = document.querySelector(".pdp");
    if (!pdp) {
      nudge.classList.remove("is-below-fold");
      return;
    }
    if (pastPdpChrome()) nudge.classList.add("is-below-fold");
    else nudge.classList.remove("is-below-fold");
  }

  function canShow() {
    if (shown || dismissed()) return false;
    if (!chatRoot() || !chatFab()) return false;
    if (chatOpen()) return false;
    if (newsletterOpen()) return false;
    if (privacyBannerOpen()) return false;
    if (!minElapsed()) return false;
    /* Narrow + mid PDP: wait until thumbs/price have scrolled up */
    if (document.querySelector(".pdp") && window.innerWidth < 960) {
      syncBelowFold();
      if (!pastPdpChrome()) return false;
    }
    return true;
  }

  function hideNudge() {
    nudge.classList.remove("is-visible");
    nudge.hidden = true;
  }

  function showNudge() {
    if (!canShow()) return;
    shown = true;
    if (delayTimer) {
      window.clearTimeout(delayTimer);
      delayTimer = null;
    }
    syncBelowFold();
    nudge.hidden = false;
    nudge.classList.add("is-visible");
  }

  function tryShow() {
    if (!canShow()) {
      if (!shown && !dismissed() && (newsletterOpen() || privacyBannerOpen() || !minElapsed())) {
        scheduleTryShow(1500);
      }
      return;
    }
    showNudge();
  }

  function openChat() {
    var fab = chatFab();
    if (!fab) return;
    if (fab.getAttribute("aria-expanded") !== "true") fab.click();
    hideNudge();
    markDismissed();
  }

  function bindScroll() {
    if (scrollBound) return;
    scrollBound = true;
    window.addEventListener(
      "scroll",
      function () {
        syncBelowFold();
        if (shown || dismissed()) return;
        if (!minElapsed()) return;
        if (document.querySelector(".pdp")) {
          if (pastPdpChrome()) tryShow();
          return;
        }
        if (pastHero()) tryShow();
      },
      { passive: true }
    );
  }

  function watchChat() {
    var fab = chatFab();
    if (!fab || fab._nudgeWatch) return;
    fab._nudgeWatch = true;
    fab.addEventListener("click", function () {
      window.setTimeout(function () {
        if (chatOpen()) {
          hideNudge();
          markDismissed();
        }
      }, 0);
    });
  }

  nudge.querySelector("[data-chat-nudge-open]")?.addEventListener("click", openChat);
  nudge.querySelector("[data-chat-nudge-close]")?.addEventListener("click", function () {
    hideNudge();
    markDismissed();
  });

  function scheduleTryShow(ms) {
    if (delayTimer) window.clearTimeout(delayTimer);
    delayTimer = window.setTimeout(tryShow, ms);
  }

  function onPopupClosed() {
    if (dismissed() || shown) return;
    var wait = Math.max(1500, minDelayMs - (Date.now() - pageLoadAt));
    scheduleTryShow(wait);
  }

  function init() {
    if (dismissed()) return;
    watchChat();
    bindScroll();
    document
      .getElementById("sora-newsletter-popup")
      ?.addEventListener("sora:popup-closed", onPopupClosed);

    var base = Number.isFinite(delayMs) ? delayMs : 16000;
    scheduleTryShow(base);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
